import { render, staticRenderFns } from "./cocal-pingcang-list.vue?vue&type=template&id=4a79055c&scoped=true&"
import script from "./cocal-pingcang-list.vue?vue&type=script&lang=js&"
export * from "./cocal-pingcang-list.vue?vue&type=script&lang=js&"
import style0 from "./cocal-pingcang-list.vue?vue&type=style&index=0&id=4a79055c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79055c",
  null
  
)

export default component.exports